document.addEventListener('DOMContentLoaded', () => {
    const tabs = document.getElementById('ProductTabs');
    const spacer = document.getElementById('ProductTabsSpacer');
    const description = document.querySelector('.product-description.page-width');

    function isMobile() { return window.matchMedia('(max-width: 1180px)').matches; }
    function getHeaderHeight() {
      const announcementOffset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-offset')) || 0;
      if(isMobile()){
        return 60 + announcementOffset;
      } else {
        return 90;
      }
    }
    function getTabHeight() { return isMobile() ? 40 : 80; }

    let isScrollingByTabClick = false;
    let clickedTabIndex = null;

    const tabItems = document.querySelectorAll('.product-tabs__nav li');
    const detailEl = document.querySelector('.product-description.page-width');
    const reviewEl = document.querySelector('.pdp-reviews-container')?.previousElementSibling;
    const relatedEl = document.querySelector('.related-products');
    const reviewSection = reviewEl?.closest('.shopify-section');

    /*추천상품 순서 변경*/
    const relatedSection = document.querySelector('.related-products')?.closest('.shopify-section');
    if(relatedSection) relatedSection.style.order = '2';

    let sizeEl = null;
    if (reviewSection) {
      const allSections = Array.from(document.querySelectorAll('.shopify-section'));
      const sizeCandidates = allSections.filter(section => {
        const hasCorrectId = section.id && section.id.includes('image_banner');
        const hasImage = section.querySelector('img') !== null;
        const isAboveRelated = section.offsetTop < relatedEl.offsetTop;
        
        return hasCorrectId && hasImage && isAboveRelated;
      });

      if (sizeCandidates.length > 0) {
        sizeEl = sizeCandidates[sizeCandidates.length - 1];
        
        if (sizeEl && !sizeEl.querySelector('.custom-size-heading')) {
          const sizeHeading = document.createElement('h2');
          sizeHeading.className = 'related-products__heading inline-richtext custom-size-heading';
          sizeHeading.innerText = '사이즈';
          sizeHeading.style.marginTop = '40px';
          sizeHeading.style.marginBottom = '20px';
          sizeHeading.style.paddingTop = '30px';
          sizeEl.prepend(sizeHeading);
        }
      }
    }

    const sections = [
      { el: detailEl, tabIndex: 0 },
      { el: sizeEl, tabIndex: 1 },
      { el: reviewEl, tabIndex: 2 },
      { el: relatedEl, tabIndex: 3 },
    ].filter((item) => item.el);
    sections.sort((a, b) => a.el.offsetTop - b.el.offsetTop);

    function activateTab(index) {
      if (index === null) return;
      tabItems.forEach((li) => li.classList.remove('is-active'));
      if (tabItems[index]) tabItems[index].classList.add('is-active');
    }

    // 초기 활성화 실행 (새로고침 대비)
    function initTabState() {
      const H_HEIGHT = getHeaderHeight();
      const currentY = window.scrollY + H_HEIGHT + getTabHeight() + 20;
      
      let found = false;
      for (let i = sections.length - 1; i >= 0; i--) {
        if (currentY >= sections[i].el.offsetTop) {
          activateTab(sections[i].tabIndex);
          found = true;
          break;
        }
      }
      if (!found) activateTab(0); // 아무것도 해당 안 되면 0번
    }

    let tabsRafPending = false;
    window.addEventListener('scroll', () => {
      if (tabsRafPending) return;
      tabsRafPending = true;
      requestAnimationFrame(() => {
        tabsRafPending = false;
        const scrollY = window.scrollY;
        const H_HEIGHT = getHeaderHeight();
        const T_HEIGHT = getTabHeight();

        const startY = spacer.offsetTop - H_HEIGHT;
        const isFixed = tabs.classList.contains('is-fixed');
        const threshold = isFixed ? startY : startY - T_HEIGHT;

      // 1. 고정 로직 (클릭 중에도 항상 실행)
        if (scrollY >= threshold) {
          if (!isFixed) {
            tabs.classList.add('is-fixed');
            spacer.style.height = T_HEIGHT + 'px';
            if (description) description.style.marginTop = '0';
          }
          tabs.style.top = H_HEIGHT + 'px';
        } else {
          if (isFixed) {
            tabs.classList.remove('is-fixed');
            spacer.style.height = '0px';
            tabs.style.top = '';
          }
        }

      // 2. 활성화 로직 잠금 (클릭 중에는 지정된 탭만 활성화)
        if (isScrollingByTabClick) {
          activateTab(clickedTabIndex);
          return;
        }

      // 3. 일반 활성화 체크
        const currentY = scrollY + H_HEIGHT + (isFixed ? T_HEIGHT : 0) + 20;
        for (let i = sections.length - 1; i >= 0; i--) {
          if (currentY >= sections[i].el.offsetTop) {
            activateTab(sections[i].tabIndex);
            break;
          }
        }
      });
    });

    tabItems.forEach((tabItem, index) => {
      const link = tabItem.querySelector('a');
      if (link) {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          let targetEl = [detailEl, sizeEl, reviewEl, relatedEl][index];
          if (!targetEl) return;

          isScrollingByTabClick = true;
          clickedTabIndex = index;
          activateTab(index);

          const targetTop = targetEl.getBoundingClientRect().top + window.scrollY;
          const startY = spacer.offsetTop - getHeaderHeight();
          const willBeFixed = targetTop >= startY;
          const offset = getHeaderHeight() + (willBeFixed ? getTabHeight() : 0);

          window.scrollTo({
            top: targetTop - offset,
            behavior: 'smooth'
          });

          // 스크롤 완료 감지 (더 정밀한 잠금 해제)
          let scrollTimeout;
          const checkScroll = () => {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
              isScrollingByTabClick = false;
              clickedTabIndex = null;
              window.removeEventListener('scroll', checkScroll);
            }, 100);
          };
          window.addEventListener('scroll', checkScroll);
        });
      }
    });

    // 실행
    initTabState();
    window.dispatchEvent(new Event('scroll'));
  });